import { createSlice } from '@reduxjs/toolkit'


export const user = createSlice({
  name: "user",
  initialState: {
    email: null,
    firstname: null,
    lastname: null,
    role: null,
    canal: null,
    admin: false,
    initalRole: null,
    keyUser: false,
    id: null,
    conso: false,
    wash: false,
    ev: false,
    cguAccteptance: false,
    globalUserEmail: null
  },
  reducers: {
    setUser: (state, item) => {
      state.email = item.payload?.email
      state.firstname = item.payload?.firstname
      state.lastname = item.payload?.lastname
      state.role = item.payload?.role
      state.canal = item.payload?.canal
      state.admin = item.payload?.admin
      state.initalRole = item.payload?.role
      state.keyUser = item.payload?.keyUser ?? false
      state.id = item.payload?.id
      state.conso = item.payload.conso
      state.wash = item.payload.wash ?? false
      state.ev = item.payload.ev ?? false
    },
    setGlobalUser: (state, item) => { 
      state.globalUserEmail = item.payload?.email;
      state.cguAccteptance = item.payload.cguAccteptance ?? false
    },
    switchAdmin: (state, item) => {
      state.role = item.payload
    }
  }
})

export const { setUser, switchAdmin, setGlobalUser } = user.actions
export default user.reducer